import store from '@/store'
import utils from '@/utils'
import Response from './response'

/**
 * Ajax通信
 */
export default class Ajax {
  /**
   * コンストラクタ
   * @param url APIのURL
   */
  constructor (url, isLongTimeout) {
    this.url = url
    this.axios = utils.axios.create(process.env.VUE_APP_API_URL, isLongTimeout)
  }

  /**
   * 送信
   * @param request
   */
  send (request) {
    utils.debug.log(`api request: ${this.url}`, request)

    const func = new Promise((resolve, reject) => {
      this.axios.post(this.url, request.data)
        .then(response => {
          const res = new Response(response.status, response.data)
          if (res.isSuccess) {
            // 成功
            utils.debug.log(`api response: ${this.url}`, res)
            resolve(res)
          } else {
            // 認証エラー
            if (res.state === 2) {
              store.commit('login_info', null)
            }

            // エラー処理
            utils.debug.error(`api response: ${this.url}`, res)
            reject(res)
          }
        })
        .catch(error => {
          // 通信エラーなど
          try {
            utils.debug.error(`api response: ${this.url}`, error)
            alert('Communication failed.\nPlease try over again.')
            reject(new Response(error.response.status, error.response.data))
          } catch (error) {
            reject(new Response(400, null, null, null, null))
          }
        })
    })

    if (process.env.NODE_ENV === 'production') {
      return func
    } else {
      return utils.sleep.msleep(Math.round(Math.random() * 3000)).then(() => func)
    }
  }
}
